import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const ChoiceType = ({choices}) => (
    <table className="table table-sm">
        <thead>
            <tr>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
            </tr>
        </thead>
        <tbody>
            {choices.map((choice) => (
                <tr key={choice.id}>
                    <td className="value-id">{choice.id}</td>
                    <td>{choice.value}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default ChoiceType;
